import TheGrid from '@/views/dealers/dsr/grid'
import Edit from '@/views/dealers/dsr/edit'

export default {
  path: '/dealers/dsr',
  redirect: '/dealers/dsr/index',
  name: 'dsr',
  meta: {
    auth: {
      redirect: {
        name: 'dsr.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'dsr.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'dsr.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'dsr.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
